var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18.3333C5.30963 18.3333 4.75 18.9302 4.75 19.6666C4.75 20.403 5.30963 21 6 21C6.69037 21 7.25 20.403 7.25 19.6666C7.25 18.9302 6.69037 18.3333 6 18.3333ZM6 18.3333V13.0001M6 19.6666L6.00888 19.6761M11 19.6666C11 22.6122 8.76138 25 6 25C3.23857 25 1 22.6122 1 19.6666C1 18.3141 1.47205 17.079 2.25 16.1388V5.00004C2.25 2.79089 3.92887 1 6 1C8.07113 1 9.75 2.79089 9.75 5.00004V16.1388C10.528 17.079 11 18.3141 11 19.6666Z",
    stroke: "#1F2D3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.99a69987a858bb0ee5d3c655946ff79a.svg";
export { ForwardRef as ReactComponent };